import {segment} from './helpers'

export const chatInitialized = () => segment('Chat initiated', {})

export const chatEnded = () => segment('Chat ended', {})
